/*
  THAANI — Produkt-Spotlight: Galerie

  Vanilla JS, kein Framework. Wechselt das grosse Bild, wenn ein Thumbnail
  geklickt wird (Tab-Muster inkl. Pfeiltasten), und folgt einem Variantenwechsel
  von Dawn (PUB_SUB_EVENTS.variantChange), sofern die Variante ein eigenes
  Hauptbild hat.
*/

if (!customElements.get('thaani-spotlight-gallery')) {
  customElements.define(
    'thaani-spotlight-gallery',
    class ThaaniSpotlightGallery extends HTMLElement {
      connectedCallback() {
        this.thumbs = Array.from(this.querySelectorAll('.thaani-spotlight__thumb'));
        this.slides = Array.from(this.querySelectorAll('.thaani-spotlight__slide'));

        if (this.thumbs.length > 1) {
          this.onThumbClick = this.handleThumbClick.bind(this);
          this.onThumbKeyDown = this.handleThumbKeyDown.bind(this);

          this.thumbs.forEach((thumb) => {
            thumb.addEventListener('click', this.onThumbClick);
            thumb.addEventListener('keydown', this.onThumbKeyDown);
          });
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            this.handleVariantChange(event);
          });
        }
      }

      disconnectedCallback() {
        if (this.thumbs) {
          this.thumbs.forEach((thumb) => {
            thumb.removeEventListener('click', this.onThumbClick);
            thumb.removeEventListener('keydown', this.onThumbKeyDown);
          });
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      handleThumbClick(event) {
        const thumb = event.currentTarget;
        this.select(this.thumbs.indexOf(thumb));
      }

      handleThumbKeyDown(event) {
        const current = this.thumbs.indexOf(event.currentTarget);
        const last = this.thumbs.length - 1;
        let next = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = current === last ? 0 : current + 1;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = current === 0 ? last : current - 1;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = last;
            break;
          default:
            return;
        }

        event.preventDefault();
        this.select(next, true);
      }

      select(index, moveFocus) {
        if (index < 0 || index >= this.thumbs.length) return;

        this.thumbs.forEach((thumb, position) => {
          const isActive = position === index;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
          thumb.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.slides.forEach((slide, position) => {
          const isActive = position === index;
          slide.classList.toggle('is-active', isActive);
          slide.toggleAttribute('hidden', !isActive);
        });

        if (moveFocus) this.thumbs[index].focus();
      }

      handleVariantChange(event) {
        const data = event && event.data;
        if (!data || data.sectionId !== this.dataset.section) return;

        const mediaId = data.variant && data.variant.featured_media && data.variant.featured_media.id;
        if (!mediaId) return;

        const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
        if (index > -1) this.select(index);
      }
    }
  );
}
